import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const AdminContainer = styled.div`
  max-width: 800px;
  margin: 4rem auto;
  padding: 2rem;
  background-color: var(--dark);
  color: var(--light);
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
`;

export const AdminTitle = styled.h1`
  font-size: 2rem;
  margin-bottom: 1.5rem;
  text-align: center;
`;

export const AdminDescription = styled.p`
  text-align: center;
  margin-bottom: 2rem;
  color: var(--gray);
`;

export const ActionsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.5rem;
`;

export const AdminButton = styled(Link)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1.5rem;
  border-radius: 10px;
  text-decoration: none;
  background: var(--primary);
  color: #fff;
  font-weight: 600;
  text-align: center;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.4);
    background: var(--primary-light);
  }
`;

export const DisabledAdminButton = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1.5rem;
  border-radius: 10px;
  background: #333;
  color: var(--gray);
  font-weight: 600;
  text-align: center;
  cursor: not-allowed;
`;

export const ComingSoonLabel = styled.span`
  margin-top: 0.5rem;
  font-size: 0.85rem;
  color: var(--gray);
`;

